import { TFunction } from 'i18next';
import { errorCodeOf, formatWait, retryAfterSecondsOf, smsNumberOf } from '../../../global/helpers/smsCodeErrors.ts';

/** What the HCP is told when a sign-in code can't be sent or isn't accepted; undefined for any other error. */
export const signInCodeMessage = (error: unknown, t: TFunction): string | undefined => {
    switch (errorCodeOf(error)) {
        case 'CodeInvalid':
            return t('activateAccount.codeInvalid');
        case 'TooManyAttempts':
            return t('signInCode.tooManyAttempts');
        case 'WaitBeforeNewCode':
            return t('activateAccount.waitBeforeNewCode', { time: formatWait(retryAfterSecondsOf(error) ?? 0) });
        case 'SmsBlocked':
            return t('activateAccount.smsBlocked', { number: smsNumberOf(error) });
        case 'CodeNotSent':
            return t('activateAccount.codeNotSent');
        default:
            return undefined;
    }
};
